<template>
  <div v-if="sponsoring">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ $t('detailProduitSponsoring.title', { libelle: sponsoring.libelle }) }}
            <b-tag v-if="getEtatProduit"
                   type="has-background-subMenu" class="has-text-white mgl-5px">
              {{$t('catalogue.etatProduit')}}
            </b-tag>
          </h1>
        </div>
        <div class="column is-narrow pdb-0">
          <div class="is-pulled-right buttons boutonAction">

            <div class="button is-addOrEdit" @click="$router.push({
            name: 'm.bodac.catalogue-editionSponsoring', params: { produitId: sponsoring.id } })">
              <span>
                {{ $t('general.button.edit') }}
              </span>
            </div>
            <button class="button"
                    @click="checkPermissions(permCatalogue.maj) ?
                      popUpCopy = true : showPopUpPermission()"
                    :class="[{'button-access-no-permission' :
           produitWithHolding},
            { 'pointer-events-none' : produitWithHolding}]">
              <b-icon icon="file-multiple" type="is-default"></b-icon>
            </button>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(permCatalogue.editer)
                      ? popUpEdition = true
                      : showPopUpPermission()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
            <piece-jointe-button :class="[{'button-access-no-permission' :
              produitWithHolding}, { 'pointer-events-none' : produitWithHolding}]"
              class="mgr-2"
              :perm="permCatalogue.maj"
              autoSave>
            </piece-jointe-button>
            <b-dropdown class="button is-bottom-left has-text-left is-relative">
              <div slot="trigger" class="right">
                <b-icon icon="call-split" type="is-default" class="mgt-5px"></b-icon>
                <b-icon icon="chevron-down" class="has-text-default"></b-icon>
              </div>
              <b-dropdown-item class="pdl-20px">
                <p class="has-text-icon-more is-size-7">
                  {{$t('catalogue.newProduct.titleAccesRapide')}}
                </p>
              </b-dropdown-item>
              <b-dropdown-item class="is-paddingless"
                               v-for="(accesRapide, index) in genererAllAccesRapide" :key="index">
                <router-link-blank :to="{ name: accesRapide.name,
                                      params: accesRapide.params}"
                                   class="pdt-5px pdb-5px"
                                   classMessage="has-text-default is-size-6 is-block
                                     mgl-20px mgr-20px"
                                   classComposant="noTextDecoration"
                                   :message="accesRapide.libelle">
                </router-link-blank>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <breadcrumb :breadcrumb="breadcrumb"/>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'produitInformation'}"
              @click="activeTab = 'produitInformation'">
            {{ $t('catalogue.newProduct.tab.product') }}
          </li>
          <li :class="{'is-active': activeTab === 'prestations'}"
              @click="activeTab = 'prestations'">
            {{ $t('catalogue.newProduct.tab.prestations') }}
          </li>
          <li :class="{'is-active': activeTab === 'TabListeLignesCommande'}"
              @click="activeTab = 'TabListeLignesCommande'">
            {{ $t('catalogue.newProduct.tab.ventes') }}
          </li>
          <li :class="{'is-active': activeTab === 'regleCommission'}"
              @click="activeTab = 'regleCommission'">
            {{ $t('catalogue.newProduct.tab.regleCommission') }}
          </li>
          <li :class="{'is-active': activeTab === 'objectifVente'}"
              @click="activeTab = 'objectifVente'">
            {{ $t('catalogue.newProduct.tab.objectifVente') }}
          </li>
          <li :class="{'is-active': activeTab === 'reglesAchat'}"
              @click="activeTab = 'reglesAchat'">
            {{ $t('catalogue.newProduct.tab.regleAchat') }}
          </li>
          <li :class="{'is-active': activeTab === 'cgv'}"
              @click="activeTab = 'cgv'">
            {{ $t('catalogue.newProduct.tab.cgv') }}
          </li>
          <li :class="{'is-active': activeTab === 'demandeInterventionType'}"
              @click="activeTab = 'demandeInterventionType'">
            {{ $t('catalogue.newProduct.tab.demandeInterventionType') }}
          </li>
        </ul>
      </div>
    </div>
    <div class="columns">
      <div class="column is-10">
        <component
          :is="activeTab"
          :produit="sponsoring"
          :sousProduit="sponsoring.produitSponsoring"
          :breadcrumb="breadcrumb"
          :commissions="sponsoring.commissionsVendeur"
          :permissions="permCatalogue"
          detail isDisabled
        />
      </div>
      <div class="column is-2">
        <div class="sticky-20px">
          <information-create-update-user :data="userInfoData"></information-create-update-user>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpCopy" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('catalogue.popUpPreventionCopy.message')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="copy"
        @no="popUpCopy = false"
      />
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="{}"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="editionProduit">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>
import { siteHasHolding } from '@/services/general/holding';
import { createNamespacedHelpers } from 'vuex';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import edition from '@/api/edition';
import { get, copieAsync } from '@/api/produit/produitSponsoring';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import Breadcrumb from '@/components/general/breadcrumb';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import objectifVente from '@/components/catalogue/produitGeneralPresse/edition/objectifVente';
import regleCommission from '@/components/catalogue/produitGeneralPresse/edition/regleCommission';
import TabListeLignesCommande from '@/components/bodac/lignesCommande/tabListeLignesCommande';
import produitInformation from '@/components/catalogue/produitGeneralPresse/detail/c_produitInformation';
import reglesAchat from '@/components/catalogue/produitGeneralPresse/edition/reglesAchat';
import cgv from '@/components/catalogue/produitGeneralPresse/edition/cgv';
import { SENS_VENTE } from '@/configuration/devisConf';
import prestations from '@/components/catalogue/produitGeneralPresse/edition/prestations';
import popUpEdition from '@/components/factures/p_edition';
import { LISTE_CHOICE_EDITION_PARUTION } from '@/configuration/presse/parution/parutionConfig';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import getUserInfoData from '@/services/general/getUserInfoData';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Attachments = createNamespacedHelpers('attachments');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'c_detailProduitSponsoring',
  data() {
    return {
      permCatalogue: CATALOGUE,
      sponsoring: null,
      activeTab: 'produitInformation',
      popUpCopy: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_PARUTION.filter(choice => choice.tousProduits),
      popUpEdition: false,
    };
  },
  components: {
    Breadcrumb,
    routerLinkBlank,
    popUpPrevention,
    objectifVente,
    TabListeLignesCommande,
    produitInformation,
    reglesAchat,
    regleCommission,
    cgv,
    prestations,
    popUpEdition,
    pieceJointeButton,
    demandeInterventionType,
    InformationCreateUpdateUser,
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async copy() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const retour = await copieAsync(this.sponsoring.id, this.$t('catalogue.labelCopy'));
        messageSucces(this.$t('catalogue.popUpPreventionCopy.success'));
        loadingComponent.close();
        await this.$router.push({
          name: 'm.bodac.catalogue-editionSponsoring',
          params: { produitId: retour.data.result.id },
        });
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async editionProduit(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.sponsoring.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    genererAllAccesRapide() {
      const accesRapides = [
        { name: 'l.bodac.commandes-liste-par-produit', params: { sens: SENS_VENTE, produitId: this.sponsoring.id }, libelle: this.$t('catalogue.newProduct.voirCommandes') },
        { name: 'l.bodac.factures-par-produit', params: { sens: SENS_VENTE, produitId: this.sponsoring.id }, libelle: this.$t('catalogue.newProduct.voirFactures') },
        { name: 'l.bodac.commandes-lignesCmd-par-produit', params: { sens: SENS_VENTE, produitId: this.sponsoring.id }, libelle: this.$t('catalogue.newProduct.voirLignesCommande') },
      ];
      if (this.modulePlanMediaActive) {
        accesRapides.push({ name: 'l.presse.plan_media', params: { produitId: this.sponsoring.id }, libelle: this.$t('catalogue.newProduct.voirPlanMedia') });
      }
      return accesRapides;
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('catalogue.titleProduit'), route: { name: 'l.bodac.catalogue' }, isActive: false },
        { title: this.$i18n.t('detailProduitSponsoring.title', { libelle: this.sponsoring.libelle }), route: { name: '' }, isActive: true },
      ];
    },
    getEtatProduit() {
      return (this.$route.params.id && !this.sponsoring.actif);
    },
    produitWithHolding() {
      return (siteHasHolding() && this.sponsoring
        && this.sponsoring.supportCommercial.societeId !== this.societeActiveId);
    },
    userInfoData() {
      return getUserInfoData(this.sponsoring, this.sponsoring?.produitSponsoring);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Sponsoring' });
      if (this.$route.params.id) {
        await this.setAttachmentElementId({ id: this.$route.params.id });
        this.sponsoring = (await get(this.$route.params.id)).data.result;
      }
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.sponsoring.libelle }));
  },
};
</script>

<style scoped>

</style>
